<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/coursetemplates/edit/' + coursetemplate.id,
          props: { id: coursetemplate.id }
        }"
        v-if="$can('coursetemplate-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(coursetemplate.id)" v-if="$can('coursetemplate-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="coursetemplate.name"
                  v-model="coursetemplate.name"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-textarea
                  name="coursetemplate.short_description"
                  v-model="coursetemplate.short_description"
                  :label="$t('coursetemplates.short_description')"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-textarea
                  name="coursetemplate.long_description"
                  v-model="coursetemplate.long_description"
                  :label="$t('coursetemplates.long_description')"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="coursetemplate.pdf_title"
                  v-model="coursetemplate.pdf_title"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.pdf_title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-textarea
                  name="coursetemplate.pdf_description"
                  v-model="coursetemplate.pdf_description"
                  :label="$t('coursetemplates.pdf_description')"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-textarea
                  name="coursetemplate.pdf_content"
                  v-model="coursetemplate.pdf_content"
                  :label="$t('coursetemplates.pdf_content')"
                  readonly
                ></v-textarea>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetemplate.info_link"
                  v-model="coursetemplate.info_link"
                  :label="$t('coursetemplates.info_link')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetypegroups.title"
                  :value="coursetypegroup.full_name"
                  :label="$t('coursetypegroups.title')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetemplate.coursetemplatetype_id"
                  :value="this.$dd_course_templates_type(coursetemplate.coursetemplatetype_id)"
                  :label="$t('coursetemplates.coursetemplatetype_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetemplate.status"
                  :value="this.$dd_course_templates_status(coursetemplate.status)"
                  :label="$t('coursetemplates.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetemplate.price"
                  v-model="coursetemplate.price"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('coursetemplates.price')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    name="coursetemplate.price_proof"
                                    v-model="coursetemplate.price_proof"
                                    :label="$t('coursetemplates.price_proof')"
                                    readonly
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>
                            <v-flex lg3 md4 sm6 xs12>
                                <v-text-field
                                    name="coursetemplate.price_vat"
                                    v-model="coursetemplate.price_vat"
                                    :label="$t('coursetemplates.price_vat')"
                                    readonly
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("coursetypes.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="ct_headers"
                  :items="coursetypes"
                  :items-per-page="coursetypes.length"
                  :options.sync="ct_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="ct_total"
                  :loading="ct_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_types_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("moduletemplates.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="mt_headers"
                  :items="moduletemplates"
                  :items-per-page="moduletemplates.length"
                  :options.sync="mt_pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="mt_total"
                  :loading="mt_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.status="{ item }">
                    {{ $dd_module_templates_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      coursetemplate: {
        has_locale: false
      },
      coursetypes: [],
      moduletemplates: [],
      coursetypegroup: {},

      ct_ids: [],
      ct_total: 0,
      ct_show_loading: false,
      ct_refresh: false,
      ct_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      ct_headers: [
        { text: this.$t("coursetypes.name"), value: "name" },
        { text: this.$t("coursetypes.category"), value: "category" },
        { text: this.$t("coursetypes.status"), value: "status" }
      ],

      mt_ids: [],
      mt_total: 0,
      mt_show_loading: false,
      mt_refresh: false,
      mt_pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      mt_headers: [
        { text: this.$t("moduletemplates.name"), value: "name" },
        { text: this.$t("moduletemplates.req_hours"), value: "req_hours" },
        { text: this.$t("moduletemplates.price"), value: "price" },
        { text: this.$t("moduletemplates.status"), value: "status" }
      ]
    }
  },

  watch: {
    ct_refresh: {
      handler() {
        if (this.ct_refresh && this.coursetemplate.id) {
          this.ct_list()
        }
      }
    },
    ct_pagination: {
      handler() {
        this.ct_refresh = true
      }
    },
    mt_refresh: {
      handler() {
        if (this.mt_refresh) {
          this.mt_list()
        }
      }
    },
    mt_pagination: {
      handler() {
        this.mt_refresh = true
      }
    }
  },

  created() {
    axios
      .get(this.API_URL + "coursetemplate/" + this.id)
      .then((res) => {
        this.coursetemplate = res.data.data
        this.coursetypegroup = this.coursetemplate.coursetypegroup
        ;(this.ct_ids = this.coursetemplate.coursetypes.map((a) => a.id)),
          (this.mt_ids = this.coursetemplate.moduletemplates.map((a) => a.id)),
          (this.page_title = this.$t("coursetemplates.view_coursetemplate", {
            name: this.coursetemplate.name
          }))

        this.ct_list()
        this.mt_list()
      })
      .catch((err) => console.log(err))
  },

  methods: {
    ct_list() {
      this.ct_show_loading = true

      let ids = this.ct_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.ct_pagination
      let query = this.$queryString(this.ct_pagination, {
        id: ids ? ids : null
      })

      axios
        .get(this.API_URL + "coursetypes" + "?" + query)
        .then((res) => {
          this.coursetypes = res.data.data
          this.ct_total = res.data.meta.total
          this.ct_refresh = false
          this.ct_show_loading = false

          this.ct_pagination.page = res.data.meta.current_page
          this.ct_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    mt_list() {
      this.mt_show_loading = true

      let ids = this.mt_ids.join(",")
      let { sortBy, descending, page, itemsPerPage } = this.mt_pagination
      let query = this.$queryString(this.mt_pagination, {
        id: ids ? ids : null
      })

      axios
        .get(this.API_URL + "moduletemplates" + "?" + query)
        .then((res) => {
          this.moduletemplates = res.data.data
          this.mt_total = res.data.meta.total
          this.mt_refresh = false
          this.mt_show_loading = false

          this.mt_pagination.page = res.data.meta.current_page
          this.mt_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
